import { SET_GENESIS_BALANCES, SET_TOTAL } from './constants';
import { GenesisAccountActions, GenesisAccountReducer } from './types';

const initState: GenesisAccountReducer = {
  accounts: [],
  total: 16,
};

export default (state = initState, action: GenesisAccountActions): GenesisAccountReducer => {
  switch (action.type) {
    case SET_GENESIS_BALANCES:
      return {
        ...state,
        accounts: action.payload,
      };
    case SET_TOTAL:
      return {
        ...state,
        total: action.payload,
      };
    default:
      return state;
  }
};
